// useLazyQueryApi.js

import {useLazyQuery} from '@apollo/client'
import {useState} from 'react'

const useLazyQueryApi = (toastmessage: any, query: any) => {
  const [errorMsg, seterrorMsg] = useState(false)
  const [getDataQuery, {loading, error, data}]: any = useLazyQuery(query, {
    fetchPolicy: 'network-only', // Ensures API is always hit
    notifyOnNetworkStatusChange: true, // Ensures state updates
  })

  const fetchData = (variables: any) => {
    seterrorMsg(false)
   return getDataQuery({
      variables: variables,
    })
  }

  if (error && !errorMsg) {
    seterrorMsg(true)
    const sessionExpirePattern = /session\s*expire/i

    // if (sessionExpirePattern.test(error?.networkError?.result?.errors[0]?.message)) {
    //   if (toastmessage) {
    //     toast.error('Session Expired! Please login again.')
    //     setTimeout(() => {
    //       dispatch(actionsUsers.logout())
    //     }, 3000)
    //   }
    // } else if (error.networkError.statusCode === 500) {
    //   toast.error(error?.networkError?.result?.errors[0]?.message)
    // } else {
    //   toast.error(`${error?.message}`)
    // }
  }

  return {
    fetchData,
    loading,
    error,
    data,
  }
}

export default useLazyQueryApi
